const language = {
	'pl': {
		'leaseFTS': 'Liczba stanowisk pracy',
		'leaseMonthlyValue': 'Miesięczna wartość umowy netto',
		'leaseStartDate': 'Data rozpoczęcia',
		'leaseEndDate': 'Data zakończenia',
		'leaseEndDateType': 'Format daty zakończenia',
	},
	'en': {
		'leaseFTS': 'Number of work stations',
		'leaseMonthlyValue': 'Lease monthly net value',
		'leaseStartDate': 'Starting date',
		'leaseEndDate': 'Ending date',
		'leaseEndDateType': 'Ending date type',
	}
}

export default language


// WEBPACK FOOTER //
// ./src/utils/lang/enquiry.js